import React from 'react'
import {useState} from 'react';
import './css/Popup.css'
import 'bootstrap/dist/css/bootstrap.css';


function Popup(props) {

    const [checkedState, setCheckedState] = useState([true, true, false, false, false, false, false, false, false, false, false, false, false, 
                                                      false, false, false, false, false, false, false, false, false, false, false]); //new Array(24).fill(""));
                                                       
    const onTrigger = (e) => {
        e.preventDefault();
        const filters = checkedState;
        props.childToParentAppliedFilters(filters);

    }

    const handleOnChange = (position) => {
        const updatedCheckedState = checkedState.map((item, index) =>
            index === position ? !item : item
        );
        setCheckedState(updatedCheckedState);


        console.log(checkedState);
    }


    return (props.trigger) ? (
        <div className = "popup">
            <div className = "popup-inner">
                <div>
                    <button className = "close-btn" onClick={() => props.setTrigger(false)}>X</button>
                    <h1>Filters:</h1>
                    <br></br>
                    <form onSubmit = {onTrigger}>
                    <div className="column">
                    <h3>Species:</h3>
                        <input type="checkbox" id="cat" value="Cat" checked={checkedState[0]} onChange={() => handleOnChange(0)}/>
                        <label for="cat"><h5>Cat</h5></label><br/>
                        <input type="checkbox" id="dog" value="Dog" checked={checkedState[1]} onChange={() => handleOnChange(1)}/>
                        <label for="dog"><h5>Dog</h5></label><br/>
                    <h3>Cat Breeds:</h3>
                        <input type="checkbox" id="domestic shorthair" value="Domestic Shorthair" checked={checkedState[2]} onChange={() => handleOnChange(2)}/>
                            <label for="domestic shorthair"><h5>Domestic Shorthair</h5></label><br/>
                        <input type="checkbox" id="domestic longhair" value="Domestic Longhair" checked={checkedState[3]} onChange={() => handleOnChange(3)}/>
                            <label for="domestic longhair"><h5>Domestic Longhair</h5></label><br/>
                        <input type="checkbox" id="misccat" value="Misc" checked={checkedState[4]} onChange={() => handleOnChange(4)}/>
                            <label for="misccat"><h5>Misc</h5></label><br/>
                            {/*Tortoiseshell, Domestic Short Hair Calico, Domestic Short Hair Tabby, European Short Hair, Bombay*/}
                            {/* 
                            <input type="checkbox" id="tortoiseshell" value="Tortoiseshell" checked={checkedState[5]} onChange={() => handleOnChange(5)}/>
                            <label for="tortoiseshell"><h5>Tortoiseshell</h5></label><br/>
                        <input type="checkbox" id="calico" value="Domestic Short Hair Calico" checked={checkedState[6]} onChange={() => handleOnChange(6)}/>
                            <label for="calico"><h5>Domestic Short Hair Calico</h5></label><br/>
                        <input type="checkbox" id="tabby" value="Domestic Short Hair Tabby" checked={checkedState[7]} onChange={() => handleOnChange(7)}/>
                            <label for="tabby"><h5>Domestic Short Hair Tabby</h5></label><br/>
                        <input type="checkbox" id="european short hair" value="European Short Hair" checked={checkedState[8]} onChange={() => handleOnChange(8)}/>
                            <label for="european short hair"><h5>European Short Hair</h5></label><br/>
                        <input type="checkbox" id="bombay" value="Bombay" checked={checkedState[9]} onChange={() => handleOnChange(9)}/>
                            <label for="bombay"><h5>Bombay</h5></label><br/>
                            */}
                    <h3>Dog Breeds:</h3>
                        <input type="checkbox" id="terrier" value="Terrier" checked={checkedState[5]} onChange={() => handleOnChange(5)}/>
                        <label for="terrier"><h5>Terrier</h5></label><br/>
                        <input type="checkbox" id="pitbull" value="Pit Bull" checked={checkedState[6]} onChange={() => handleOnChange(6)}/>
                        <label for="pitbull"><h5>Pit Bull</h5></label><br/>
                        <input type="checkbox" id="labrador retriever" value="Labrador Retriever" checked={checkedState[7]} onChange={() => handleOnChange(7)}/>
                        <label for="labrador retriever"><h5>Labrador Retriever</h5></label><br/>
                        <input type="checkbox" id="german shepard" value="German Shepard" checked={checkedState[8]} onChange={() => handleOnChange(8)}/>
                        <label for="german shepard"><h5>German Shepherd</h5></label><br/>
                        <input type="checkbox" id="hound" value="hound" checked={checkedState[9]} onChange={() => handleOnChange(9)}/>
                        <label for="hound"><h5>Hound</h5></label><br/>
                        <input type="checkbox" id="mixed" value="Mixed Breed" checked={checkedState[10]} onChange={() => handleOnChange(10)}/>
                        <label for="mixed"><h5>Mixed Breed</h5></label><br/>
                        <input type="checkbox" id="miscdog" value="Misc" checked={checkedState[11]} onChange={() => handleOnChange(11)}/>
                            <label for="miscdog"><h5>Misc</h5></label><br/>
                        {/* Mastiff, Rhodesian Ridgeback, Basenji, Greater Swiss Mountain Dog, American Bulldog, Shepherd, Collie, Beagle, Catahoula
                         Dachshund, Jack Russel Terrier, Min Pin*/}

                    </div>

                    <div className="column">                    
                    <h3>Sex:</h3>
                        <input type="checkbox" id="m" value="Male" checked={checkedState[12]} onChange={() => handleOnChange(12)}/>
                            <label for="m"><h5>Male</h5></label><br/>
                        <input type="checkbox" id="f" value="Female" checked={checkedState[13]} onChange={() => handleOnChange(13)}/>
                            <label for="f"><h5>Female</h5></label><br/>
                    <h3>Size:</h3>
                        <input type="checkbox" id="small" value="Small" checked={checkedState[14]} onChange={() => handleOnChange(14)}/>
                            <label for="small"><h5>Small</h5></label><br/>
                        <input type="checkbox" id="medium" value="Medium" checked={checkedState[15]} onChange={() => handleOnChange(15)}/>
                            <label for="medium"><h5>Medium</h5></label><br/>
                        <input type="checkbox" id="large"value="Large" checked={checkedState[16]} onChange={() => handleOnChange(16)}/>
                            <label for="large"><h5>Large</h5></label><br/>
                    <h3>Age:</h3>
                        <input type="checkbox" id="baby" value="Baby" checked={checkedState[17]} onChange={() => handleOnChange(17)}/>
                            <label for="baby"><h5>Baby</h5></label><br/>
                        <input type="checkbox" id="young" value="Young" checked={checkedState[18]} onChange={() => handleOnChange(18)}/>
                            <label for="young"><h5>Young</h5></label><br/>
                        <input type="checkbox" id="adult" value="Adult" checked={checkedState[19]} onChange={() => handleOnChange(19)}/>
                            <label for="adult"><h5>Adult</h5></label><br/>
                        <input type="checkbox" id="senior" value="Senior" checked={checkedState[20]} onChange={() => handleOnChange(20)}/>
                            <label for="senior"><h5>Senior</h5></label><br/>
                    <h3>Shelter:</h3>
                        <input type="checkbox" id="caa" value="Companion Animal Alliance" checked={checkedState[21]} onChange={() => handleOnChange(21)}/>
                            <label for="caa"><h5>Companion Animal Alliance</h5></label><br/>
                        <input type="checkbox" id="catHaven" value="Cat Haven" checked={checkedState[22]} onChange={() => handleOnChange(22)}/>
                            <label for="catHaven"><h5>Cat Haven</h5></label><br/>
                        <input type="checkbox" id="caaws" value="Capital Area Animal Welfare Society" checked={checkedState[23]} onChange={() => handleOnChange(23)}/>
                            <label for="caaws"><h5>Capital Area Animal Welfare Society</h5></label><br/>
                    </div>
                    <button class="btn btn-light" className = "applyButton"type="submit">Apply Filters</button>
                    </form>  
                </div>
            </div>
        </div>
    ) : "";
}

export default Popup
